var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11154_89235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.111084,
    y: 0.111115,
    width: 53.7778,
    height: 53.7778,
    rx: 1.05941,
    fill: "#4035DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0205 34.4515V39.5556H24.6098H5.48877V14.0934H24.6098H26.0205V21.2999H17.5443V23.2504H26.0205V32.5009C25.251 32.4542 24.4698 32.3608 23.677 32.2323C20.2959 31.6717 17.999 30.527 17.9757 30.5153L17.1013 32.2557C17.2062 32.3024 19.643 33.5288 23.2923 34.1361C24.2017 34.2996 25.1228 34.3931 26.0205 34.4515ZM39.9998 23.2504V21.2999H48.511V14.0934H27.9676V32.536C30.8241 32.4542 33.5173 31.7885 36.0007 30.5153L36.8752 32.2557C34.1469 33.6339 31.1272 34.3814 27.9559 34.4748V39.5556H48.511V23.2504H39.9998Z",
    fill: "#39D723"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11154_89235"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.111084,
    y: 0.111115,
    width: 53.7778,
    height: 53.7778,
    rx: 4.88889,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.8928856d3461c60e6348ddf901664abf.svg";
export { ForwardRef as ReactComponent };